import { assignment, paged } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function find({ url: { service: baseURL }, token }: IAPI) {
  return async function find(
    input: assignment.FindAssignmentsInput,
    page?: Partial<paged.Params>
  ): Promise<assignment.FindAssignmentsResult> {
    const url = new URL(`/assignment/application`, baseURL);
    for (const [key, value] of Object.entries(input)) {
      url.searchParams.set(key, value);
    }
    for (const [key, value] of Object.entries(page ?? {})) {
      url.searchParams.set(key, value.toString());
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to find assignments');
    }
  };
}
